import React from 'react';
import { Icon } from './Icon.js';
export const IconHeadphones2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.11282 14H8V21H3V11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11V21H16V14H20.8923", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHeadphones2.js.map